import "./styles.css";

import Form from "../../components/Form";

const FormPage = () => {
  return (
    <section id="formPage">
      <article className="container">
        <div className="left">
          <h2 className="title">Garanta Agora Mesmo o SAV</h2>

          <p className="text">
            E aumente a eficiência das suas inspeções de segurança!
          </p>
        </div>

        <div className="right">
          <p className="text">Preencha o formulário, entraremos em contato:</p>

          <Form />
        </div>
      </article>
    </section>
  );
};

export default FormPage;
